import React from "react";
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import * as FileSaver from 'file-saver';

import { exportToExcel as exportToExcelAgenda } from '../../api/agenda';
import { exportToExcel as exportToExcelPrescription } from '../../api/prescriptionReport';
import { Success } from "../Notifications/Notifications";
import { HandleApiError } from "../Notifications/APIErrorHandler";
import { withTranslation } from 'react-i18next';

class ExportToExcel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        isLoading: false,
        };
        this.onClick = this.onClick.bind(this);
    }

    async onClick() {
        try {
        this.setState({ isLoading: true });

        const { filters, context } = this.props;

        const exportFunction = context === "agenda" ? exportToExcelAgenda : exportToExcelPrescription;
        const response = await exportFunction(filters);

        const data = new Blob([response.data], { type: response.headers['content-type'] });

        let filename = "Turnos.xlsx";
        const disposition = response.headers["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
            }
        }

        FileSaver.saveAs(data, filename);
        Success("commons.exported", this.props.t);
        } catch (error) {
        console.error("[Export] Error al exportar a Excel:", error.message);
        HandleApiError(error, this.props.t);
        } finally {
        this.setState({ isLoading: false });
        }
    }

    render() {
        const { isLoading } = this.state;
        const { t } = this.props;

        return (
        <Button
            bsStyle="success"
            onClick={this.onClick}
            disabled={isLoading}
            style={{ float: 'right' }}
        >
            {isLoading
            ? <span><i className="fa fa-spinner fa-spin me-2" /> {t('buttons.loading')}</span>
            : <span><i className="fa fa-file-excel-o me-2" /> {t('buttons.export')}</span>
            }
        </Button>
        );
    }
}

    ExportToExcel.propTypes = {
    filters: PropTypes.object.isRequired,
    context: PropTypes.string.isRequired,
    };

export default withTranslation()(ExportToExcel);
